import { Link } from 'react-router-dom';
import { useSupport } from '../support/SupportWidget';
import { useTour } from '../tour/context';

export function Help() {
  const { openSupport } = useSupport();
  const { start: startTour } = useTour();

  return (
    <div>
      <div className="console-head">
        <div>
          <h1>Help &amp; support</h1>
          <div className="sub">Get set up, check your equipment, and find answers.</div>
        </div>
      </div>

      <div className="section-title">Getting started</div>
      <div className="wf-picker">
        <button type="button" className="wf-pick-card" onClick={startTour}
          style={{ textAlign: 'left', cursor: 'pointer', font: 'inherit', color: 'inherit', width: '100%' }}>
          <div className="wf-pick-top"><span className="wf-tag">Tour</span></div>
          <h3>Take the guided tour</h3>
          <p>A one-minute walkthrough of the system — installing the Device Service, checking your scanner, capturing a transaction, and tracking it through to the results.</p>
          <span className="wf-pick-go">Start the tour →</span>
        </button>
      </div>

      <div className="section-title">Contact us</div>
      <div className="wf-picker">
        <button type="button" className="wf-pick-card" onClick={openSupport}
          style={{ textAlign: 'left', cursor: 'pointer', font: 'inherit', color: 'inherit', width: '100%' }}>
          <div className="wf-pick-top"><span className="wf-tag">Support</span></div>
          <h3>Get help</h3>
          <p>Ask our support assistant — it can answer questions and look up your own account details — or open a support ticket and we'll follow up by email.</p>
          <span className="wf-pick-go">Open the assistant →</span>
        </button>
      </div>

      <div className="section-title">Diagnostics</div>
      <div className="wf-picker">
        <Link to="/app/help/device" className="wf-pick-card">
          <div className="wf-pick-top"><span className="wf-tag">Diagnostics</span><span className="pill-scan">Scanner</span></div>
          <h3>Device status</h3>
          <p>Verify the Device Service is running, see connected scanners, and check your device libraries.</p>
          <span className="wf-pick-go">Open →</span>
        </Link>
        {/*
          * Beside Device status, because both are "my hardware is not behaving" — and a barcode scanner
          * that strips line endings looks identical to a bad scan, so the customer has nothing to search
          * for unless we put it somewhere they will pass.
          */}
        <Link to="/app/help/barcode-scanner" className="wf-pick-card">
          <div className="wf-pick-top"><span className="wf-tag">Setup</span><span className="pill-scan">Barcode</span></div>
          <h3>Barcode scanner setup</h3>
          <p>Configure a barcode scanner to read a driver&rsquo;s licence and fill the demographic form. Includes the Teemi setup barcodes.</p>
          <span className="wf-pick-go">Open →</span>
        </Link>
      </div>

      <div className="section-title">Resources</div>
      <div className="wf-picker">
        <Link to="/app/downloads" className="wf-pick-card">
          <div className="wf-pick-top"><span className="wf-tag">Downloads</span></div>
          <h3>Download the Device Service</h3>
          <p>Install or update the local Device Service and scanner drivers for your workstation.</p>
          <span className="wf-pick-go">Go to downloads →</span>
        </Link>
        <Link to="/app/support" className="wf-pick-card">
          <div className="wf-pick-top"><span className="wf-tag">Support</span></div>
          <h3>My support tickets</h3>
          <p>View your open and past support requests and reply to our team.</p>
          <span className="wf-pick-go">View tickets →</span>
        </Link>
      </div>
    </div>
  );
}
